import { Message } from 'element-ui';
import { Decrypt, Encrypt } from '@/common/aes/utils.js';
import router from '@/router.js';
import store from '@/store';

// const baseURL = 'https://sj2.f7ad.cn/admin/v1'; // 正式 
const baseURL = 'https://sj2.leqiuad.vip/admin/v1'; //正式
// const baseURL = 'https://sj2.byunfs.cn/admin/v1'; // 测试服

function fetchInstance(url, options) {
    options.body = options.body || {}; // 初始化 options.body
    // 切换F7,93数据源
    let DataSources = window.sessionStorage.getItem("DataSources");
    // 渠道号
    options.body.admin_check = DataSources || 0;
    let token = window.sessionStorage.getItem('token')
    if (token) {
        options.body.token = token || '';
    }
    let setdata = options.body;
    for (let i in options) {
        if (options.hasOwnProperty(i) && i != 'method' && i != 'body') {
            setdata[i] = options[i];
        }
    }
    options.body = setdata
    options.body = JSON.stringify(options.body); // 将请求体参数转换为JSON字符串

    return new Promise((resolve, reject) => {
        fetch(baseURL + url, options)
            .then(response => response.json())
            .then(res => {
                let data = JSON.parse(Decrypt(res.encryption));
                if (data.code !== 1) {
                    Message.error(data.msg);
                }

                if (data.errorCode === 2001) {
                    store.commit('logout');
                    router.push({
                        name: 'login'
                    });
                }

                resolve({ data });
            })
            .catch(error => {
                reject(error);
            });
    });
}

export default fetchInstance;
